import {FC} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import {PersonnelListHeader} from './components/header/PersonnelListHeader'
import {KTCard} from '../../../_metronic/helpers'
import {PersonnelManagement} from './PersonnelManagement'
import { PersonnelPageTitle } from '../../../_metronic/layout/core/PersonnelPageData'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const PersonnelManagementWrapper: FC = () => {
  return (
    <>
      <PersonnelPageTitle
        icon='Icon.svg'
        title='Employees'
        // desc={totalPersonnel.toString()+ ' Employees'}
        desc='Manage your employees to ensure compliance and simplify audits'
        breadcrumbs={usersBreadcrumbs}
      >
        Personnel Management
      </PersonnelPageTitle>
      <KTCard>
        <PersonnelListHeader />
        <PersonnelManagement className='mb-5 mb-xl-8' allPoliciesChecked={false} />
      </KTCard>
    </>
  )
}

export default PersonnelManagementWrapper
